import React, { Fragment } from 'react';
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;

const DocumentationContact = () => {
    return (
        <Fragment>
            <div className="documentation-info-view__contact">
                <i className="icons icons--icon-phone-blue"></i>
                <p className="font-paragraph2">
                    <strong className="title">
                        <FormattedText value="documentation-contactTitle" />
                    </strong>
                    <br />
                    <FormattedText value="documentation-contactTextPart1" />
                    <a className="aBlue" href={formatText('documentation-contactMailTo')}>
                        <FormattedText value="documentation-contactEmail" />
                    </a>
                    <FormattedText value="documentation-contactTextPart2" />
                </p>
            </div>
        </Fragment>
    );
};

export default DocumentationContact;
